<div id="error-404" class="h-dvh leading-[1.4]" fxLayout="column" fxLayoutAlign="center center">
  <div class="content text-center">
    <div class="error-code">404</div>
    <div class="message mb-10 text-black-text/54">
      Sorry but we could not find the page you are looking for
    </div>
    <a class="back-link" [routerLink]="'/matters'">Go back to dashboard</a>
  </div>
</div>
